import WorkoutConflictReviewFeed from './WorkoutConflictReviewFeed';

export default WorkoutConflictReviewFeed;
